import React from 'react';
import * as LucideIcons from 'lucide-react';

interface IconProps {
  name: string;
  className?: string;
  size?: number;
}

export const Icon: React.FC<IconProps> = ({ name, className = 'w-5 h-5', size }) => {
  // Megkeressük a Lucide ikont név alapján
  const IconComponent = (LucideIcons as Record<string, any>)[name] || LucideIcons.FileText;
  return <IconComponent className={className} size={size} />;
};
